import { fexPut } from "@/utils/fex"

export const fixOrdinals = async ({pageId}:{pageId:string})=>{
    const resp = await fexPut(`api/page/fix-ordinals/${pageId}`,{})
    
    // window.location.reload()
}